import React from 'react';
import './Testimonials.css';

const testimonials = [
    {
      name: 'Franco D.',
      location: 'Washington Crossing, PA',
      text: 'You can get a ride from anywhere but when I need someone reliable and local there`s no better car service than CabNHaul. They are dependable, honest, and top notch.',
      rating: 5,
    },
    {
      name: 'Cindy',
      location: 'Langhorne, PA',
      text: "I have had the pleasure to utilize George's services multiple times when traveling to and from my destinations. He has excellent driving skills which include but not limited to consistent safety awareness , navigating very well in challenging traffic situations that always allows me to feel comfortable and safe. Above all, George priorities customer service, ALWAYS RESPECTFUL and VERY KIND.... in other words IMPECCABLE!",
      rating: 5,
    },
  {
    name: 'Todd G.',
    location: 'Yardley, PA',
    text: 'George is very reliable and always on time. His cars are super clean and very comfortable. I highly recommend his services!',
    rating: 5,
  },
  {
    name: 'Bob',
    location: 'Newtown, PA',
    text: "I have used George multiple times and found his service to be professional and timely with nice clean vehicles.",
    rating: 5,
  },
  {
    name: 'Colin C.',
    location: 'Yardley, PA',
    text: "I wouldn't trust anyone but CABNHAUL when I've absolutely gotta get there. Courtesy, comfort, and class that can't be beat. Paying for airport parking is crazy when you can get a ride with George!",
    rating: 5,
  },
];

const StarRating: React.FC<{ rating: number }> = ({ rating }) => {
  return (
    <div className="star-rating">
      {[...Array(5)].map((_, index) => (
        <span key={index} className={index < rating ? 'star filled' : 'star'}>
          ★
        </span>
      ))}
    </div>
  );
};

const Testimonials: React.FC = () => {
  return (
    <div className="testimonials-section">
      <h2 className="testimonials-title">Testimonials</h2>
      <div className="testimonials-grid">
        {testimonials.map((testimonial, index) => (
          <div key={index} className="testimonial-card">
            <StarRating rating={testimonial.rating} />
            <p className="testimonial-text">"{testimonial.text}"</p>
            <div className="testimonial-author">
              <div className="author-avatar">
                {testimonial.name.charAt(0)}
              </div>
              <div className="author-info">
                <p className="author-name">{testimonial.name}</p>
                <p className="author-location">{testimonial.location}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Testimonials; 